/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Directive, HostListener, ElementRef } from '@angular/core';
@Directive({
  selector: '[numberDots]',
})
export class NumberDotsDirective {
  regexStr = '^[0-9]*$';

  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: any): boolean {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('input', ['$event'])
  onKeyPressFinish(ev: Event): void {
    this.validateFields(ev);
  }

  validateFields(event: Event): void {
    const val = this.el.nativeElement.value as string;
    event.preventDefault();
    event.stopPropagation();
    this.el.nativeElement.value = this.numberWithCommas(val);
  }

  numberWithCommas(n: string): string {
    n = n.replace(/\,/g, '');
    n = n.replace(/\./g, '');
    const parsed = n.replace(/\B(?=(?:\d{3})+(?!\d))/g, '.');
    return parsed;
  }
}
